import React from 'react'
import { Drawer } from 'antd'
import './resizable-drawer.scss'
import { LocalStorageKeys } from '../../../constants'
import useLocalStorage from '../../../hooks/useLocalStorage'

let isResizing = null

const ResizableDrawer = ({ children, width: defaultWidth = 720, minWidth = 256, maxWidth = 1200, ...props }) => {
    const [drawerWidth, setDrawerWidth] = useLocalStorage(LocalStorageKeys.DRAWER_WIDTH, defaultWidth)

    const cbHandleMouseMove = React.useCallback(handleMousemove, [])
    const cbHandleMouseUp = React.useCallback(handleMouseup, [])

    function handleMouseup() {
        if (!isResizing) return
        isResizing = false
        document.removeEventListener('mousemove', cbHandleMouseMove)
        document.removeEventListener('mouseup', cbHandleMouseUp)
    }

    function handleMousedown(e) {
        e.stopPropagation()
        e.preventDefault()
        // we will only add listeners when needed, and remove them afterward
        document.addEventListener('mousemove', cbHandleMouseMove)
        document.addEventListener('mouseup', cbHandleMouseUp)
        isResizing = true
    }

    function handleMousemove(e) {
        const offsetRight = document.body.offsetWidth - (e.clientX - document.body.offsetLeft)
        if (offsetRight > minWidth && offsetRight < maxWidth) setDrawerWidth(offsetRight)
    }

    return (
        <Drawer {...props} width={drawerWidth}>
            <div className='sidebar-dragger' onMouseDown={handleMousedown} />
            {children}
        </Drawer>
    )
}

export default ResizableDrawer
